import { MenuItemOption } from '@chakra-ui/react'

export default MenuItemOption
